/**
 * configuration for the GAMS application
 *
 * Please use """ in this module
 */
define('atn/config',["common/config", "./messages","lodash"],
    function(apiBaseConfig, messages,_) {
        "use strict";

        /**
         * basepath of the api
         * @type {string}
         */
        
        var apiPath = apiBaseConfig.apiPath;
        /**
         * config for the application
         * @type {Object}
         */
        var config = {};
        /**
         * [customerId - customer id of the loggedin user]
         * @type {string}
         */
        config.customerId = apiBaseConfig.customerId;
        config.uiDisplayStrings = messages.uiDisplayStrings;
        /**
         * url for signin/login page
         * DONOT FREEZE
         *
         * @type {String}
         */
        config.signInUrl = "./login.html";

        /**
         * url for index.html
         * DONOT FREEZE
         *
         * @type {String}
         */
        config.indexUrl = "./index.html";

        /**
         * url for showing logout page
         * DONOT FREEZE
         *
         * @type {String}
         */
        config.signOutUrl = "./logout.html";
        /**
         * url for showing error page
         * DONOT FREEZE
         *
         * @type {String}
         */
        config.errorUrl = "./error.html";

        /**
         * status test for jquery ajax timeout
         * @type {String}
         */
        config.ajaxTimeoutStatusText = "timeout";

        /**
         * message to be shown on request time-out
         * @type {String}
         */
        config.timeoutMessage = "Your request has been timed-out";
        /**
         * offset for GMT
         * @type {String}
         */
        config.utcOffset = "+00:00";
        /**
         * [dateFormatString format string for converting dateObjs to string]
         * @type {String}
         */
        config.dateFormatString = "DD MMM YY hh:mm A";

        /**
         * [dateFormatStringMsecs: format string for converting dateObjs to string with milliseconds precision]
         * @type {String}
         */
        config.dateFormatStringStandard = "YYYY-MM-DD HH:mm:ss";
        /**
         * [dateFormatStringAmPm format string for AM/PM and '/' delimited dates.]
         * @type {String}
         */
        config.timeGeneratedOnFormat = "HH:mm:ss";

        config.dayGeneratedOnFormat = "DD MMM YY";

        config.kendoDateFormat = " dd MMM yy";

        config.kendoFullDateFormat = "dd MMM yy hh:mm tt";

        config.oemRebrandingFolder = "oem/__default/";

        config.oemResourcesMap = {
            LOGO: "img/company-logo.png",
            FAVICON: "img/favicon.ico",
            LOGIN: "img/login-box-icon.png",
            MESSAGES: "config.json",
            PDF_LOGO: "img/companyLogo.dataURI"
        };

        /**
         * URL base paths for apis
         * @type {Object}
         */
        config.api = {
            timezones: apiPath + "timezones",
            customers: apiPath + "customers/",
            analytics:  apiPath + "data",
            site: apiPath + "site",
            sso_enabled: apiPath + "site",
            roles: apiPath + "roles",
            login: apiPath + "site/login",
            logout: apiPath + "site/logout",
            casLogout: apiPath + "site/casLogout",
            sessionData: apiPath + "sessions/current",
            customerInfo: apiPath + "customers/",
            reports: apiPath + "reportschedules",
            reporting: apiPath + "reportschedules/",
            userPreferences: apiPath + "userpreferences",
            dashboards: '/dashboards.json',
            rawDataReportColumns: apiPath + 'rawdatareportcolumns'
        };
        config.roles = {
            superAdmin: 1,
            admin: 2,
            operator: 3,
            analyst: 4,
            marketing: 5
        };

        /* ENUM for current saving status
         * @type {Object}
         */
        config.SAVING_STATUS = {
            INIT: "",
            SUCCESS: "successful",
            FAIL: "failed",
            IMPORT: "importsuccess"
        };

        /*
         * HTTPS Status codes used in REST API
         */
        config.httpStatusCodes = {
            locked: 423
        };

        /**
         * [keyboardCharCodes ENUM for the character codes for keyboard related events]
         * @type {Object}
         */
        config.keyboardCharCodes = {
            KEYBOARD_RETURN: 13
        };

        config.updateBrandInfo = function(brandInfo){
            var tempMessages;
            tempMessages = JSON.stringify(messages.messages);
            tempMessages = tempMessages.replace(/{BRAND}/gi,brandInfo.short_name);
            tempMessages = tempMessages.replace(/{BRAND_FULL_NAME}/gi,brandInfo.full_name);
            tempMessages = tempMessages.replace(/{BRAND_EMAIL}/gi,brandInfo.support_email);
            tempMessages = tempMessages.replace(/{BRAND_PATENT_INFO}/gi,brandInfo.patent_info);
            tempMessages = tempMessages.replace(/{BRAND_SHORT_NAME}/gi,brandInfo.patent_info);
            

            config.messages = {};
            _.assign(config.messages,JSON.parse(tempMessages));
        };

        return config;
    });
